export const FALLBACK_IMG =
  "https://images.unsplash.com/photo-1771969703191-74381c286cac?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHw0fHxjYXJnbyUyMHNoaXAlMjBvY2VhbiUyMHR3aWxpZ2h0fGVufDB8fHx8MTc4ODIyNDEwMXww&ixlib=rb-4.1.0&q=85";

const U = (id) => `https://images.unsplash.com/${id}?auto=format&fit=crop&w=1600&q=80`;

export const COMMODITIES = [
  {
    slug: "crude-oil",
    industryIdx: 0,
    img: "https://images.pexels.com/photos/30123684/pexels-photo-30123684.jpeg?auto=compress&cs=tinysrgb&w=1600",
    name: { en: "Crude Oil", fr: "Pétrole Brut", ar: "النفط الخام", zh: "原油" },
    desc: {
      en: "Norex sources crude oil allocations from verified producers and allocation holders, with a focus on West African grades such as Bonny Light and Forcados. We coordinate specification verification, commercial structuring, and delivery to refineries and traders worldwide.",
      fr: "Norex source des allocations de pétrole brut auprès de producteurs et détenteurs d'allocations vérifiés, avec un focus sur les bruts ouest-africains comme le Bonny Light et le Forcados. Nous coordonnons la vérification des spécifications, la structuration commerciale et la livraison aux raffineries et négociants du monde entier.",
      ar: "تورّد نوركس مخصصات النفط الخام من منتجين وحاملي مخصصات موثقين، مع التركيز على الخامات غرب الأفريقية مثل بوني لايت وفوركادوس. ننسق التحقق من المواصفات والهيكلة التجارية والتسليم للمصافي والتجار حول العالم.",
      zh: "Norex 从经过验证的生产商和配额持有方采购原油配额，重点关注邦尼轻质油和福卡多斯等西非油种。我们协调规格验证、商务结构设计，并向全球炼厂和贸易商交付。",
    },
    specs: ["Grades: Bonny Light, Forcados, Qua Iboe, Arab Light", "API gravity: 28°–36° typical", "Sulfur: sweet (<0.5%) and sour options", "Cargo sizes: 500,000 – 2,000,000 bbl", "Terms: FOB / CIF, TTO or TTT structures", "Docs: SGS/CIQ inspection, certificate of origin"],
    regions: ["Nigeria", "Angola", "Saudi Arabia", "UAE", "USA", "Brazil"],
  },
  {
    slug: "petroleum-products",
    industryIdx: 0,
    img: "https://images.pexels.com/photos/10407689/pexels-photo-10407689.jpeg?auto=compress&cs=tinysrgb&w=1600",
    name: { en: "Petroleum Products", fr: "Produits Pétroliers", ar: "المنتجات البترولية", zh: "石油产品" },
    desc: {
      en: "We connect buyers with refineries and major traders for EN590 10ppm diesel, Jet A1 aviation fuel, gasoline, and fuel oils — from single spot cargoes to structured monthly supply programs.",
      fr: "Nous connectons les acheteurs aux raffineries et grands négociants pour le diesel EN590 10ppm, le carburant aviation Jet A1, l'essence et les fiouls — de la cargaison spot aux programmes d'approvisionnement mensuels structurés.",
      ar: "نربط المشترين بالمصافي وكبار التجار لديزل EN590 بكبريت 10ppm ووقود الطيران Jet A1 والبنزين وزيوت الوقود — من الشحنات الفورية إلى برامج التوريد الشهرية المنظمة.",
      zh: "我们为买家对接炼厂和大型贸易商，供应EN590 10ppm柴油、Jet A1航空燃油、汽油和燃料油——从现货船货到结构化月度供应计划。",
    },
    specs: ["EN590 diesel: 10ppm sulfur, EN590:2009", "Jet A1: DEF STAN 91-91 / ASTM D1655", "PMS: 91–95 RON gasoline", "Volumes: 10,000 – 100,000 MT monthly", "Terms: FOB Rotterdam/Fujairah, CIF ASWP", "Inspection: SGS, Saybolt or equivalent at load port"],
    regions: ["UAE", "Netherlands", "Singapore", "Nigeria", "India", "USA"],
  },
  {
    slug: "lng",
    industryIdx: 0,
    img: "https://images.unsplash.com/photo-1771969703191-74381c286cac?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHw0fHxjYXJnbyUyMHNoaXAlMjBvY2VhbiUyMHR3aWxpZ2h0fGVufDB8fHx8MTc4ODIyNDEwMXww&ixlib=rb-4.1.0&q=85",
    name: { en: "LNG", fr: "GNL", ar: "الغاز الطبيعي المسال", zh: "液化天然气" },
    desc: {
      en: "Norex facilitates LNG supply from liquefaction projects and portfolio players for utility and industrial buyers — supporting spot purchases as well as long-term sale and purchase agreements.",
      fr: "Norex facilite l'approvisionnement en GNL depuis les projets de liquéfaction et les acteurs de portefeuille, pour les acheteurs utilities et industriels — achats spot comme contrats de vente long terme (SPA).",
      ar: "تسهّل نوركس توريد الغاز الطبيعي المسال من مشاريع الإسالة ومحافظ اللاعبين الكبار للمشترين من المرافق والصناعة — دعم المشتريات الفورية واتفاقيات البيع والشراء طويلة الأمد.",
      zh: "Norex 为公用事业和工业买家协调来自液化项目和组合供应商的液化天然气供应——支持现货采购及长期购销协议(SPA)。",
    },
    specs: ["Delivery: DES / FOB", "Carriers: 140,000 – 174,000 m³", "Quality per SPA (GHV, methane number)", "Contracts: spot, short-term, long-term SPA", "Docs: Q88, quality certificates"],
    regions: ["Qatar", "Nigeria (NLNG)", "USA", "Australia", "Mozambique"],
  },
  {
    slug: "lpg",
    industryIdx: 0,
    img: "https://images.pexels.com/photos/11489637/pexels-photo-11489637.jpeg?auto=compress&cs=tinysrgb&w=1600",
    name: { en: "LPG", fr: "GPL", ar: "غاز البترول المسال", zh: "液化石油气" },
    desc: {
      en: "Propane–butane LPG for cooking gas, industrial, and autogas markets. We arrange pressurized cargo supply with complete documentation for importers and distributors.",
      fr: "GPL propane-butane pour les marchés du gaz de cuisine, de l'industrie et du carburant. Nous organisons l'approvisionnement en cargaisons pressurisées avec documentation complète pour importateurs et distributeurs.",
      ar: "غاز بترول مسال بروبان-بيوتان لأسواق غاز الطهي والصناعة ووقود السيارات. نرتب توريد شحنات مضغوطة بوثائق كاملة للمستوردين والموزعين.",
      zh: "面向民用燃气、工业和车用市场的丙烷-丁烷液化石油气。我们为进口商和分销商安排带完整单证的加压船货供应。",
    },
    specs: ["Mix: 30/70, 50/50 propane/butane or pure grades", "Corrosion: copper strip class 1", "Volatility per EN 589 / ASTM D1835", "Volumes: 2,000 – 20,000 MT", "Terms: FOB / CFR, pressurized or semi-ref vessels"],
    regions: ["Nigeria", "Algeria", "Qatar", "USA", "Kazakhstan"],
  },
  {
    slug: "iron-ore",
    industryIdx: 1,
    img: U("photo-1504328345606-18bbc8c9d7d1"),
    name: { en: "Iron Ore", fr: "Minerai de Fer", ar: "خام الحديد", zh: "铁矿石" },
    desc: {
      en: "Hematite and magnetite iron ore in lumps and fines for steel mills, with verified assays and complete export documentation from mine to vessel.",
      fr: "Minerai de fer hématite et magnétite, en lumps et fines pour les aciéries, avec analyses vérifiées et documentation d'export complète de la mine au navire.",
      ar: "خام حديد هيماتيت ومغنتيت، كتل وناعم لمصانع الصلب، مع تحاليل موثقة ووثائق تصدير كاملة من المنجم إلى السفينة.",
      zh: "为钢厂供应块矿和粉矿形式的赤铁矿和磁铁矿，附有经验证的化验报告以及从矿山到船上的完整出口单证。",
    },
    specs: ["Fe content: 58% – 65%+", "Forms: fines, lumps, pellet feed", "Moisture: <8% typical", "Volumes: 30,000 – 150,000 MT per shipment", "Packing: bulk vessel", "Inspection: SGS/AHK assay at load port"],
    regions: ["Brazil", "Australia", "South Africa", "India", "Guinea"],
  },
  {
    slug: "gold",
    industryIdx: 1,
    img: U("photo-1610375461246-83df859d849d"),
    name: { en: "Gold", fr: "Or", ar: "الذهب", zh: "黄金" },
    desc: {
      en: "Gold dore bars and bullion from licensed miners and refineries, transacted through secure, documented channels with full assay and compliance support.",
      fr: "Lingots d'or doré et bullion de mineurs et raffineries licenciés, traités via des canaux sécurisés et documentés, avec analyse complète et support conformité.",
      ar: "سبائك الذهب الخام والمشغول من منجمين ومصافٍ مرخصة، عبر قنوات آمنة وموثقة مع دعم كامل للتحليل والامتثال.",
      zh: "来自持牌矿商和精炼厂的金锭(dore)和金条，通过安全、有据可查的渠道交易，提供完整化验和合规支持。",
    },
    specs: ["Purity: 92% – 99.99% (dore to fine gold)", "Forms: dore bars, LBMA good-delivery bullion", "Assay: refinery or independent (Alex Stewart / SGS)", "Transaction: CIF refinery-to-refinery or FOB", "Compliance: KYC, export permits, AML documentation"],
    regions: ["Ghana", "South Africa", "Mali", "UAE (refining)", "Switzerland"],
  },
  {
    slug: "copper",
    industryIdx: 1,
    img: "https://images.pexels.com/photos/3721272/pexels-photo-3721272.jpeg?auto=compress&cs=tinysrgb&w=1600",
    name: { en: "Copper", fr: "Cuivre", ar: "النحاس", zh: "铜" },
    desc: {
      en: "Grade A copper cathodes and copper concentrate for cable, electronics, and industrial manufacturers — matched to LME-registered and non-registered supply.",
      fr: "Cathodes de cuivre Grade A et concentré de cuivre pour les fabricants de câbles, d'électronique et d'industrie — approvisionnement enregistré LME ou non.",
      ar: "كاثودات نحاس درجة A ومركزات النحاس لمصنعي الكابلات والإلكترونيات والصناعة — بإمداد مسجل أو غير مسجل في بورصة لندن للمعادن.",
      zh: "为电缆、电子和工业制造商供应A级阴极铜和铜精矿——可对接LME注册及非注册货源。",
    },
    specs: ["Cathodes: 99.99% purity, LME Grade A", "Concentrate: 20–30% Cu typical", "Bundles: 25 – 125 kg sheets", "Volumes: 500 – 10,000 MT monthly", "Terms: FOB / CIF, LC or TT"],
    regions: ["DR Congo", "Zambia", "Chile", "Peru", "Kazakhstan"],
  },
  {
    slug: "manganese",
    industryIdx: 1,
    img: U("photo-1523848309072-c199db53f137"),
    name: { en: "Manganese", fr: "Manganèse", ar: "المنغنيز", zh: "锰" },
    desc: {
      en: "Manganese ore for steel and alloy production, sourced from established mines with consistent Mn content, sizing, and shipment reliability.",
      fr: "Minerai de manganèse pour la production d'acier et d'alliages, provenant de mines établies avec teneur en Mn, granulométrie et fiabilité d'expédition constantes.",
      ar: "خام المنغنيز لإنتاج الصلب والسبائك، من مناجم راسخة بمحتوى منغنيز ثابت وأحجام منتظمة وموثوقية في الشحن.",
      zh: "用于钢铁和合金生产的锰矿石，来自成熟矿山，锰含量稳定、粒度均匀、发运可靠。",
    },
    specs: ["Mn content: 38% – 48%+", "Forms: lumpy (10–75mm) and fines", "Mn/Fe ratio per buyer specification", "Volumes: 5,000 – 50,000 MT", "Packing: bulk or 1MT jumbo bags"],
    regions: ["South Africa", "Gabon", "Ghana", "Australia", "Brazil"],
  },
  {
    slug: "medicines-pharmaceuticals",
    industryIdx: 2,
    img: U("photo-1584308666744-24d5c474f2ae"),
    name: { en: "Medicines & Pharmaceuticals", fr: "Médicaments & Produits Pharmaceutiques", ar: "الأدوية والمنتجات الصيدلانية", zh: "药品与制药" },
    desc: {
      en: "Essential medicines, generics, and APIs from WHO-GMP certified manufacturers — with regulatory dossiers, cold-chain logistics, and tender documentation support.",
      fr: "Médicaments essentiels, génériques et principes actifs (API) de fabricants certifiés OMS-GMP — avec dossiers réglementaires, logistique chaîne du froid et support documentaire pour appels d'offres.",
      ar: "أدوية أساسية وأدوية جنيسة ومواد فعالة (API) من مصنعين معتمدين WHO-GMP — مع ملفات تنظيمية ولوجستيات سلسلة التبريد ودعم وثائق المناقصات.",
      zh: "来自WHO-GMP认证生产商的基本药物、仿制药和原料药——提供注册文件、冷链物流和投标单证支持。",
    },
    specs: ["Certification: WHO-GMP, ISO, PIC/S facilities", "Range: generics, OTC, hospital supplies, APIs", "Documentation: CoA, MSDS, registration dossiers", "Cold chain: validated 2–8°C shipping available", "MOQs per manufacturer program"],
    regions: ["India", "Nigeria", "Egypt", "Germany", "Turkey"],
  },
  {
    slug: "medical-devices",
    industryIdx: 2,
    img: U("photo-1532187863486-abf9dbad1b69"),
    name: { en: "Medical Devices", fr: "Dispositifs Médicaux", ar: "الأجهزة الطبية", zh: "医疗器械" },
    desc: {
      en: "Diagnostic, surgical, and laboratory equipment from CE / ISO 13485 certified producers — from hospital tenders to complete laboratory fit-outs.",
      fr: "Équipements de diagnostic, de chirurgie et de laboratoire de producteurs certifiés CE / ISO 13485 — des appels d'offres hospitaliers aux équipements complets de laboratoires.",
      ar: "معدات التشخيص والجراحة والمختبرات من منتجين معتمدين CE / ISO 13485 — من مناقصات المستشفيات إلى تجهيز المختبرات الكاملة.",
      zh: "来自CE / ISO 13485认证生产商的诊断、外科和实验室设备——从医院招标到完整实验室配置。",
    },
    specs: ["Standards: CE marked, ISO 13485, FDA-listed options", "Range: diagnostics, imaging, surgical instruments, lab equipment", "Warranty & after-sales via manufacturer", "Documentation: technical files, certificates of conformity", "Installation support on project supply"],
    regions: ["Germany", "China", "Japan", "USA", "Turkey"],
  },
  {
    slug: "industrial-machinery",
    industryIdx: 3,
    img: "https://images.unsplash.com/photo-1565377167263-d29b5ac85479?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHw0fHxpbmR1c3RyaWFsJTIwbWFjaGluZXJ5JTIwZmFjdG9yeXxlbnwwfHx8fDE3ODgyMjQxMDF8MA&ixlib=rb-4.1.0&q=85",
    name: { en: "Industrial Machinery", fr: "Machines Industrielles", ar: "الآلات الصناعية", zh: "工业机械" },
    desc: {
      en: "Heavy machinery, plant equipment, and OEM spare parts — excavators, generators, processing lines — sourced new or certified pre-owned with full documentation.",
      fr: "Machines lourdes, équipements d'usine et pièces détachées OEM — excavateurs, groupes électrogènes, lignes de production — neufs ou d'occasion certifiée avec documentation complète.",
      ar: "آلات ثقيلة ومعدات مصانع وقطع غيار أصلية — حفارات ومولدات وخطوط إنتاج — جديدة أو مستعملة معتمدة بوثائق كاملة.",
      zh: "重型机械、工厂设备和OEM备件——挖掘机、发电机、生产线——全新或认证二手，单证齐全。",
    },
    specs: ["New and certified pre-owned equipment", "OEM genuine and OEM-equivalent spare parts", "Brands: Caterpillar, Komatsu, Siemens and equivalents", "Docs: test certificates, manuals, warranty terms", "Delivery: EXW to DAP project site"],
    regions: ["China", "Germany", "Japan", "USA", "India"],
  },
  {
    slug: "agricultural-commodities",
    industryIdx: 4,
    img: "https://images.pexels.com/photos/27037415/pexels-photo-27037415.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    name: { en: "Agricultural Commodities", fr: "Commodités Agricoles", ar: "السلع الزراعية", zh: "农产品" },
    desc: {
      en: "Sesame seed, cashew nuts, cocoa, ginger, hibiscus, and grains from verified aggregators and farms — graded, bagged, and export-documented.",
      fr: "Graines de sésame, noix de cajou, cacao, gingembre, hibiscus et céréales d'agrégateurs et fermes vérifiés — triés, ensachés et documentés pour l'export.",
      ar: "بذور السمسم والكاجو والكاكاو والزنجبيل والكركديه والحبوب من مجمعين ومزارع موثقة — مصنفة ومعبأة وموثقة للتصدير.",
      zh: "来自经验证的收购商和农场的芝麻、腰果、可可、生姜、洛神花和谷物——分级、袋装并备齐出口单证。",
    },
    specs: ["Sesame: 99% purity, whitish/black varieties", "Cashew: W320/W240 kernels or RCN", "Cocoa: grade 1 fermented beans", "Packing: 25/50kg PP bags, container or breakbulk", "Docs: phytosanitary, fumigation, certificate of origin"],
    regions: ["Nigeria", "Benin", "Tanzania", "Côte d'Ivoire", "Brazil"],
  },
  {
    slug: "textiles-garments",
    industryIdx: 5,
    img: U("photo-1523381210434-271e8be1f52b"),
    name: { en: "Textiles & Garments", fr: "Textiles & Vêtements", ar: "المنسوجات والملابس", zh: "纺织与服装" },
    desc: {
      en: "Fabrics, apparel, and corporate uniform programs — from mill to packed garment, with independent quality inspection before every shipment.",
      fr: "Tissus, vêtements et programmes d'uniformes d'entreprise — de la filature au vêtement emballé, avec inspection qualité indépendante avant chaque expédition.",
      ar: "أقمشة وملابس وبرامج زي موحد للشركات — من المصنع إلى الملابس المعبأة، مع فحص جودة مستقل قبل كل شحنة.",
      zh: "面料、服装和企业制服项目——从纱厂到包装成衣，每次发货前均经独立质量检验。",
    },
    specs: ["Fabrics: cotton, poly-cotton, technical textiles", "Garments: T-shirts, workwear, uniforms, PPE clothing", "MOQs: from 500 units per style typical", "Quality: AQL 2.5 pre-shipment inspection", "Labels & packaging per buyer specification"],
    regions: ["China", "India", "Turkey", "Pakistan", "Nigeria"],
  },
  {
    slug: "construction-materials",
    industryIdx: 6,
    img: U("photo-1541888946425-d81bb19240f5"),
    name: { en: "Construction Materials", fr: "Matériaux de Construction", ar: "مواد البناء", zh: "建筑材料" },
    desc: {
      en: "Cement, structural steel, rebar, and finishing materials for contractors and project developers — delivered in line with site schedules.",
      fr: "Ciment, acier de construction, fer à béton et matériaux de finition pour entrepreneurs et promoteurs — livrés selon les calendriers de chantier.",
      ar: "أسمنت وحديد إنشائي وحديد تسليح ومواد تشطيب للمقاولين والمطورين — تسليم وفق جداول مواقع العمل.",
      zh: "为承包商和项目开发商供应水泥、结构钢、螺纹钢和装饰材料——按工地进度交付。",
    },
    specs: ["Cement: 42.5R / 52.5N Portland, bagged or bulk", "Steel: rebar B500B, sections, plate", "Finishing: tiles, sanitary ware, electrical", "Volumes: container loads to bulk vessel", "Delivery: CIF port or DAP site"],
    regions: ["Turkey", "China", "Egypt", "Nigeria", "Vietnam"],
  },
];

export const getCommodity = (slug) => COMMODITIES.find((c) => c.slug === slug);
